<div class="flex flex-col min-h-screen bg-gray-100 dark:bg-gray-900">
  @if (isAuthenticated()) {
  <app-header></app-header>
  }

  <app-progress-bar></app-progress-bar>

  <div class="flex flex-grow">
    @if (isAuthenticated() && showSidenav()) {
    <app-sidenav class="w-64 bg-white dark:bg-gray-800 shadow-lg"></app-sidenav>
    }

    <main class="flex-1 overflow-y-auto" [class.p-4]="isAuthenticated()">
      <router-outlet></router-outlet>
    </main>
  </div>

  @if (isAuthenticated()) {
  <app-footer></app-footer>
  }
</div>

@if (isAuthenticated() && isHelpDeskModalOpen()) {
<app-modal
  [isOpen]="isHelpDeskModalOpen()"
  (close)="closeHelpDeskModal()"
  title="Help Desk: Support Request"
>
  <app-help-desk (close)="closeHelpDeskModal()"></app-help-desk>
</app-modal>
}

<app-tailwind-toast-message></app-tailwind-toast-message>
